//注册全局方法
import { ElMessage } from 'element-plus'
import store from '@/store'

export function message(text,type){
  let types = 'success'
  if(type == 1){
    types = "warning"
  }else if(type == 2){
    ElMessage.error(text)
    return
  }
  ElMessage({
    message: text,
    type: types,
  })
};

//深copy
export function copy(obj){
  if(!obj){
    return
  }
  var newobj = obj.constructor === Array ? [] : {};
  if(typeof obj !== 'object'){
    return
  }
  for(var i in obj){
    newobj[i] = typeof obj[i] === 'object' ? this.$qzfCopy(obj[i]) : obj[i];
  }
  return newobj
};

export function fplx(code){
  if(code == '004'){
    return "增值税专用发票"
  }else if(code == '007'){
    return "增值税普通发票"
  }else if(code == '025'){
    return "卷式发票"
  }else if(code == '026'){
    return "电子普通发票"
  }else if(code == '005'){
    return "机动车发票"
  }else if(code == '006'){
    return "二手车销售统一发票"
  }else if(code == '028'){
    return "增值税电子专用发票"
  }
}

export function checkStrInArray(arr, str){
  let s = arr.filter(v=>{return str == v})
  if(s.length != 0){
    return true
  }
  return false
}


export function getUrlParams2(url, name) { // 不传name返回所有值，否则返回对应值
  if (url.indexOf('?') == 1) { return false; }
  url = url.substr(1);
  url = url.split('&');
  var name = name || '';
  var nameres;
  // 获取全部参数及其值
  for(var i=0;i<url.length;i++) {
    var info = url[i].split('=');
    var obj = {};
    obj[info[0]] = decodeURI(info[1]);
    url[i] = obj;
  }
  // 如果传入一个参数名称，就匹配其值
  if (name) {
    for(var i=0;i<url.length;i++) {
      for (const key in url[i]) {
          if (key == name) {
              nameres = url[i][key];
          }
        }
    }
  } else {
    nameres = url;
  }
  // 返回结果
  return nameres;
}

export function getUrlParams(url, name) { // 不传name返回所有值，否则返回对应值
  let s = url.split('?')
  if(s.length < 2){
    return ""
  }
  let cs = s[1]
  let csArr = cs.split('&')
  let val = ''
  csArr.map(v=>{
    if(name == v.split('=')[0]){
      val = v.split('=')[1]
    }
  })
  return val
}


//过滤科目 1只要最下级
export function subjectFilterCode(codes, type) {
  //subjects
  let list = []
  if(type == 1){
    list = store.getters['commons/subjectsLower']
  }else{
    list = store.getters['commons/subjects']
  }
  if(codes.length == 0){
    return list
  }
  return list.filter(v => {
    if (codes.indexOf(v.code.substring(0, 4)) > -1) {
      return v
    }
  })
}

export function findCode(arr){
  let codes = store.getters['user/comInfo'].codes
  let list = arr.map(v=>{
    return codes[v]
  })
  return list
}
//原型链上增加方法
// String.prototype.moneyFilter = function(){
//   if(this.indexOf('(') > -1){
//     let amount = this.replace("(", "").replace(")","")
//     return Number((-amount.replace(/,/g, "").replace("¥", "").replace("å", "").replace("元", "").replace("￥", "")  * 1).toFixed(2))
//   }else{
//     return Number((this.replace(/,/g, "").replace("¥", "").replace("å", "").replace("元", "").replace("￥", "")  * 1).toFixed(2))
//   }
// }


export function buttonStatus(code) {
  if(store.getters['user/user'].sysButton.indexOf(code) > -1){
    return false;
  }else{
    return true;
  }
}


export function checkSettleStatus(){
  let comPeriod = {}
  store.getters['commons/periods'][0].options.map(v=>{
    if(store.getters['user/comInfo'].period == v.period){
      comPeriod = v
    }
  })
  if(comPeriod.settleStatus == 4){
    return '本期已结账，请先进行反结账'
  }
  return ""
}

export function inventoryTypeFilter(type){  //存货类别filter
  if(type == 1){
    return "原材料"
  }else if(type == 2){
    return "库存商品"
  }else if(type == 3){
    return "半成品"
  }else if(type == 4){
    return "委托加工物资"
  }else if(type == 5){
    return "周转材料"
  }else if(type == 6){
    return "包装物"
  }else if(type == 7){
    return "消耗性生物资产"
  }else if(type == 8){
    return "工程物资"
  }else if(type == 9){
    return "开发产品"
  }else if(type == 10){
    return "发出产品"
  }else if(type == 11){
    return "其他"
  }
}

export function inventoryCategoryFilter(type){  //存货类型filter
  if(type == 1){
    return "初始化导入"
  }else if(type == 2){
    return "进项入库-进项发票录入"
  }else if(type == 3){
    return "暂估入库"
  }else if(type == 4){
    return "生产商品入库(生产结转)"
  }else if(type == 6){
    return "领料出库(生产结转)"
  }else if(type == 7){
    return "商品结转出库(贸易结转)"
  }else if(type == 8){
    return "抵消销项卖出(特殊)"
  }else if(type == 9){
    return "销项卖出-销项发票录入"
  }else if(type == 10){
    return "手工出库"
  }else if(type == 11){
    return "手工入库"
  }else if(type == 12){
    return "凭证关联出库"
  }else if(type == 13){
    return "凭证关联入库"
  }else if(type == 31){
    return "暂估回冲"
  }else if(type == 91){
    return "销项回冲"
  }
}

export function VoucherSourceFilter(type){  //凭证来源filter
  if(type == '1'){
    return "进项"
  }else if(type == '2'){
    return "销项"
  }else if(type == '3'){
    return "费用"
  }else if(type == '4'){
    return "现金"
  }else if(type == '5'){
    return "票据"
  }else if(type == '6'){
    return "银行"
  }else if(type == '7'){
    return "工资"
  }else if(type == '8'){
    return "结转损益"
  }else if(type == '9'){
    return "计提税金"
  }else if(type == '10'){
    return "资产"
  }else if(type == '12'){
    return "存货结转"
  }else if(type == '13'){
    return "暂估回冲"
  }else if(type == '14'){
    return "暂估入库"
  }else if(type == '20'){
    return "进项认证"
  }else if(type == '30'){
    return "固定资产清理"
  }else if(type == '40'){
    return "汇兑损益"
  }else if(type == '100'){
    return "年末结转利润"
  }else if(type == '手工录入'){
    return "手工录入"
  }
}

//获取本账期最后一天
export function getPeriodTime(filterVal, jsonData) {
  let period = store.getters['user/comInfo'].period
  let ri = '31'
  if(period.slice(4,6) == 2){
    ri = '28'
  }else if(period.slice(4,6) == '04' || period.slice(4,6) == '06' || period.slice(4,6) == '09' || period.slice(4,6) == '11'){
    ri = '30'
  }

  let str = period.slice(0,4) + '-' + period.slice(4,6) + "-" + ri
  return new Date(str)
}

export function tableNameFilter(type){  //税务报表名称过滤
  if(type == 'kj_lrb'){
    return "利润表"
  }else if(type == 'kj_zcfz'){
    return "资产负债表"
  }else if(type == 'gs_vat'){
    return "增值税及附加税一般纳税人申报表"
  }else if(type == 'gs_small_vat'){
    return "小规模增值税纳税及附加税申报表"
  }else if(type == 'gs_deed'){
    return "财产和行为税纳税申报表"
  }else if(type == 'gs_tax_quarter'){
    return "企业所得税申报表"
  }else if(type == 'gs_gs'){
    return "综合所得个人所得税预扣预缴申报表"
  }else if(type == 'gs_fjs'){
    return "附加税"
  }else if(type == 'gs_whsyjsfsbbygz'){
    return "文化事业建设费申报表"
  }else if(type == 'gs_stamp_duty_item'){
    return "印花税纳税申报表"
  }else if(type == 'gs_xfs'){
    return "消费税"
  }else if(type == 'gs_cbj'){
    return "残疾人就业保障金申报表"
  }else if(type == 'gs_ghjf'){
    return "工会经费"
  }else if(type == 'gs_fcs'){
    return "房产税土地税"
  }else if(type == 'gs_fssr'){
    return "非税收入"
  }else if(type == 'gs_stamp_duty_item_cb'){
    return "印花税纳税申报表"
  }else if(type == 'gs_stamp_duty_item_jb'){
    return "印花税纳税申报表"
  }else if(type == 'gs_sl'){
    return "水利建设专项收入"
  }else if(type == 'gs_ljcl'){
    return "城市生活垃圾处置费"
  }else if(type == 'gs_qtsr'){
    return "工会经费"
  }else if(type == 'gs_gs_one'){
    return "个人生产经营所得(查账征收)"
  }else if(type == 'kj_xjllb'){
    return "现金流量表"
  }else if(type == 'gs_sb'){
    return "单位社会保险费日常申报(全责)"
  }else if(type == 'gs_cwbb'){
    return "财务报表"
  }
}

export function taxPayerTypeFilter(type){
  if(type == '1'){
    return "小规模纳税人"
  }else if(type == "2"){
    return "一般纳税人"
  }
}

// 申报状态
export function setUpStatusSb(type){
  if(type == '0' || type == ''){
    return '未申报'
  }else if(type == '1'){
    return '排队中'
  }else if(type == '2'){
    return '申报中'
  }else if(type == '3'){
    return '申报完成'
  }else if(type == '4'){
    return '申报失败'
  }else if(type == '5'){
    return '税局处理中'
  }else if(type == '6'){
    return '已申报过'
  }else if(type == '7'){
    return '申报异常'
  }
}

// 扣款状态
export function setUpStatusKk(type){
  if(type == '0' || type == ''){
    return '未扣款'
  }else if(type == '1'){
    return '排队中'
  }else if(type == '2'){
    return '扣款中'
  }else if(type == '3'){
    return '扣款成功'
  }else if(type == '4'){
    return '无需扣款'
  }else if(type == '5'){
    return '扣款异常'
  }
}

// 检查状态
export function setUpStatusJc(type){
  if(type == '0'){
    return '未检查'
  }else if(type == '1'){
    return '排队中'
  }else if(type == '2'){
    return '检查中'
  }else if(type == '3'){
    return '检查通过'
  }else if(type == '4'){
    return '检查异常'
  }
}

// 采集状态
export function setUpStatusCj(type){
  if(type == '0'){
    return '未采集'
  }else if(type == '1'){
    return '排队中'
  }else if(type == '2'){
    return '采集中'
  }else if(type == '3'){
    return '采集完成'
  }else if(type == '4'){
    return '采集失败'
  }else if(type == '5'){
    return '异常'
  }
}

// 导入状态
export function setUpStatusImport(type){
  if(type == '0'){
    return '未导入'
  }else if(type == '1'){
    return '排队中'
  }else if(type == '2'){
    return '导入中'
  }else if(type == '3'){
    return '导入完成'
  }else if(type == '4'){
    return '导入失败'
  }else if(type == '5'){
    return '错误'
  }
}

// 匹配状态
export function setUpStatusMatch(type){
  if(type == '0'){
    return '未匹配'
  }else if(type == '1'){
    return '排队中'
  }else if(type == '2'){
    return '匹配中'
  }else if(type == '3'){
    return '匹配完成'
  }else if(type == '4'){
    return '匹配失败'
  }else if(type == '5'){
    return '错误'
  }
}
// 采集状态
export function setUpStatusQY(type){
  if(type == '0'){
    return '未迁移'
  }else if(type == '1'){
    return '排队中'
  }else if(type == '2'){
    return '迁移中'
  }else if(type == '3'){
    return '迁移完成'
  }else if(type == '4'){
    return '迁移失败'
  }else if(type == '5'){
    return '异常'
  }
}
// 个税申报状态
export function  setUpStatusGsSb(type){
  if(type == '0'){
    return '未申报'
  }else if(type == '1'){
    return '排队中'
  }else if(type == '2'){
    return '申报中'
  }else if(type == '3'){
    return '申报超时失败'
  }else if(type == '4'){
    return '客户端未启动失败'
  }else if(type == '5'){
    return '申报异常'
  }else if(type == '6'){
    return '申报失败'
  }else if(type == '7'){
    return '申报成功，待缴款'
  }else if(type == '8'){
    return '自动检查中'
  }else if(type == '10'){
    return '申报成功，无需缴款'
  }else if(type == '11'){
    return '扣款中'
  }else if(type == '12'){
    return '扣款异常'
  }else if(type == '13'){
    return '申报成功，扣款成功'
  }else if(type == '14'){
    return '已申报过'
  }
}